import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const clientApiUrl = process.env.REACT_APP_CLIENT_API_URL;

const ClientDatasetAPI = {
	getDatset: (request: ClientSiteSingleDatasetRequest) => {
		return axios
			.get(
				`${clientApiUrl}/organizations/${request.organizationId}/datasets/${request.datasetId}`
			)
			.then((response) => response.data as DatasetDTO);
	},
};

export default ClientDatasetAPI;
